import { type ReactNode, createContext, useContext } from "react";

interface FormContextValue {
  /** オペレーションタスクインスタンスID */
  operationTaskInstanceId?: string;
}

const FormContext = createContext<FormContextValue | undefined>(undefined);

interface FormContextProviderProps {
  value: FormContextValue;
  children: ReactNode;
}

/**
 * フォームコンテキストプロバイダー
 *
 * フォーム内のフィールドがAPIリクエストに必要な情報を取得できるようにします。
 */
export const FormContextProvider = ({
  value,
  children,
}: FormContextProviderProps) => {
  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

/**
 * フォームコンテキストを取得するフック
 */
export const useFormContext = () => {
  const context = useContext(FormContext);
  return context;
};
